import React from 'react'

function findElementByScrollName(name) {
  if (!name && name !== 0) return null
  const targetName = String(name)

  const byDataName = Array.from(document.querySelectorAll('[data-scroll-name]')).find(
    (el) => el.getAttribute('data-scroll-name') === targetName,
  )
  if (byDataName) return byDataName

  const byName = Array.from(document.getElementsByName(targetName))[0]
  if (byName) return byName

  const byId = document.getElementById(targetName)
  if (byId) return byId

  return null
}

function scrollToElement(to, offset = 0, smooth = true) {
  const target = findElementByScrollName(to)
  if (!target) return

  const top = target.getBoundingClientRect().top + window.pageYOffset + Number(offset || 0)
  window.scrollTo({
    top,
    behavior: smooth === false ? 'auto' : 'smooth',
  })
}

export function Element({ name, children, className, style, ...rest }) {
  return (
    <div data-scroll-name={name} className={className} style={style} {...rest}>
      {children}
    </div>
  )
}

export function Link({
  to,
  children,
  className,
  activeClass,
  style,
  offset = 0,
  smooth = true,
  onClick,
  href,
  duration,
  spy,
  hashSpy,
  isDynamic,
  ignoreCancelEvents,
  containerId,
  delay,
  activeStyle,
  ...rest
}) {
  const handleClick = (event) => {
    event.preventDefault()
    if (typeof onClick === 'function') onClick(event)
    scrollToElement(to, offset, smooth)
  }

  return (
    <a
      href={href || `#${encodeURIComponent(String(to || ''))}`}
      className={className || activeClass}
      style={style}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </a>
  )
}

export const Events = {
  scrollEvent: {
    register: () => {},
    remove: () => {},
  },
}

export const scrollSpy = {
  update: () => {},
}

export const scroller = {
  scrollTo: (to, options = {}) => scrollToElement(to, options.offset, options.smooth),
}

export const animateScroll = {
  scrollToTop: (options = {}) => {
    window.scrollTo({ top: 0, behavior: options.smooth === false ? 'auto' : 'smooth' })
  },
}

export default {
  Element,
  Link,
  Events,
  scrollSpy,
  scroller,
  animateScroll,
}
